export default "__VITE_PUBLIC_ASSET__fc62b360__"